<template>
  <div class="page">
		<PageHeader>
			Настройка резерва
		</PageHeader>

		<div class="content">
			<form v-if="valutes" @submit.prevent="Manupulate()">
				<div class="item">
					<label>Валюта:</label>
					<select v-model="reserve.valuteId">
						<option selected disabled>Не выбрано</option>
						<option v-for="valute in valutes" :key="valute._id" :value="valute._id">{{ valute.title }}</option>
					</select>
				</div>

				<div class="item">
					<label>Резерв:</label>
					<input type="text" placeholder="руб." v-model="reserve.balance">
				</div>

				<button>{{ !!reserve._id ? 'Сохранить' : 'Добавить' }}</button>
			</form>
			
			<h4 style="padding: 5px;">Резервы:</h4>
			<hr>
			<table v-if="reserves.length" style="width: 100%">
				<tr style="border-bottom: 2px solid #d9d9d9">
					<td>ID</td>
					<td>Валюта</td>
					<td>Баланс</td>
					<td></td>
				</tr>
				<tr
					:key="reserve._id"
					v-for="reserve in reserves"
					>
					<td>{{ reserve._id }}</td>
					<td v-if="reserve.valuteId && reserve.valuteId === valute._id" v-for="valute in valutes" :key="valute._id">{{ valute.title }}</td>
					<td>{{ reserve.balance }}</td>
					<td>
						<button style="display: inline-block;" @click.prevent="editReserve(reserve)">edit</button>
						<button style="display: inline-block;" @click.prevent="removeReserve(reserve._id)">delete</button>
					</td>
				</tr>
			</table>
		</div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { getReserve, addReserve, editReserve, deleteReserve } from '@/api'
import PageHeader from "../../ui/PageHeader.vue";
//
export default {
  components: { PageHeader },
  name: 'Main',

	data: () => ({
		reserve: {
			_id: null,
			valuteId: null,
			balance: 0,
		},
		reserves: [],
	}),

	computed: {
		...mapState('auth', ['session']),
		...mapState('valutes', ['valutes']),
	},

	mounted () {
		this.getValutes()
		this.loadReserve()
	},

	methods: {
		...mapActions('valutes', ['getValutes']),

		async Manupulate () {
			if (!!this.reserve._id) {
				await editReserve(this.reserve)
			} else {
				await addReserve(this.reserve)
			}
			
			this.loadReserve()

			this.reserve._id = null
			this.reserve.balance = 0
		},

		loadReserve () {
			return getReserve ()
				.then(response => {
					this.reserves = response.data.result
				})
		},

		editReserve (reserve) {
			this.reserve = reserve
		},

		removeReserve (id) {
			deleteReserve(id)
				.then(data => {
					this.loadReserve()
				})
		}
	}
}
</script>

<style scoped>
.item {
	display: block;
	margin: 5px 0;
}

.item > label,
.item > input {
	display: inline-block;
}

.item > textarea {
	display: block;
	margin-top: 5px;
	padding: 7px;
	font-family: verdana;
	width: 95%;
	min-height: 250px;

}
</style>



// WEBPACK FOOTER //
// src/components/pages/Reserve/index.vue